import SoAppNotificationList from './SoAppNotificationList';
import SoAppNotificationShow from './SoAppNotificationShow';
import SoAppNotificationCreate from './SoAppNotificationCreate';

export default {
    list: SoAppNotificationList,
    show: SoAppNotificationShow,
    create: SoAppNotificationCreate
}